// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-document-version-list {
  display: block;
  background-color: var(--fi-color-white);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./Source/app/document/version-list/version-list.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,uCAAA;EACA,UAAA;AACJ","sourcesContent":[".fi-document-version-list {\r\n    display: block;\r\n    background-color: var(--fi-color-white);\r\n    z-index: 2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
